var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding" }, [
    _c("div", { staticClass: "row gutter-sm" }, [
      _vm.webcast.webcast_type === 1
        ? _c(
            "div",
            {
              staticClass: "col-xs-12",
              class: _vm.webcast.use_chat ? "col-sm-8" : "col-sm-12"
            },
            [
              _c("webcast-youtube", {
                attrs: { source: _vm.youtubeParser(_vm.webcast.embed) }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.webcast.webcast_type === 2 &&
      !_vm.load_wowza_player &&
      !_vm.webcast.transmission_downloaded &&
      (_vm.live && !_vm.live.st)
        ? _c(
            "div",
            {
              staticClass: "col-xs-12",
              class: _vm.webcast.use_chat ? "col-sm-8" : "col-sm-12"
            },
            [
              _c("div", { staticClass: "webcast-poster" }, [
                _c("p", [_vm._v(_vm._s(this.$t("webcast_not_started")))])
              ])
            ]
          )
        : _vm._e(),
      _vm.webcast.webcast_type === 2 &&
      _vm.load_wowza_player &&
      !_vm.webcast.transmission_downloaded &&
      (_vm.live && _vm.live.st)
        ? _c(
            "div",
            {
              staticClass: "col-xs-12",
              class: _vm.webcast.use_chat ? "col-sm-8" : "col-sm-12"
            },
            [
              _c("webcast-wowza", {
                attrs: { source: _vm.webcast, refresh: true }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.webcast.webcast_type === 2 && _vm.webcast.transmission_downloaded
        ? _c(
            "div",
            {
              staticClass: "col-xs-12",
              class: _vm.webcast.use_chat ? "col-sm-8" : "col-sm-12"
            },
            [
              _c("video-plyr", {
                attrs: { file_url: _vm.webcast.embed, id: _vm.webcast.id }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.webcast.webcast_type === 3
        ? _c(
            "div",
            {
              staticClass: "col-xs-12",
              class: _vm.webcast.use_chat ? "col-sm-8" : "col-sm-12"
            },
            [_c("webcast-vimeo", { attrs: { source: _vm.webcast.embed } })],
            1
          )
        : _vm._e(),
      _vm.webcast.use_chat
        ? _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-4",
              style: _vm.$q.platform.is.mobile
                ? ""
                : "height: " + _vm.video_height + "px;"
            },
            [
              _vm.webcast.id
                ? _c("chat", {
                    attrs: {
                      id_webcast: _vm.webcast.id,
                      type_chat: "public",
                      order: "t",
                      from_home: true
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.webcast.use_chat
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    helper: _vm.webcast.chat_moderated
                      ? _vm.$t(
                          "all_questions_will_be_moderated_before_showing_on_chat"
                        )
                      : ""
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("new_message"),
                      disable: _vm.webcast.status === 4
                    },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.sendMessage()
                      }
                    },
                    model: {
                      value: _vm.new_message,
                      callback: function($$v) {
                        _vm.new_message = $$v
                      },
                      expression: "new_message"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm.webcast.use_chat
      ? _c("div", { staticClass: "row gutter-sm justify-end q-mt-md" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-3" },
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: "secondary",
                  label: _vm.$t("send"),
                  icon: "far fa-comment-dots",
                  disable: _vm.webcast.status === 4
                },
                on: {
                  click: function($event) {
                    return _vm.sendMessage()
                  }
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }